import type { AxiosRequestConfig } from 'axios';
import Axios from 'axios';

import { API_URL } from 'constants/environment';

const BASE_URL_V2 = `${API_URL}/api/v2`;

export const AXIOS_INSTANCE = Axios.create({ baseURL: BASE_URL_V2 });

export const customAxiosInstance = async <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<T> => {
  const abortController = new AbortController();
  const promise = AXIOS_INSTANCE({
    signal: abortController.signal,
    ...config,
    ...options
  }).then(({ data }) => data);

  // @ts-expect-error Set cancel of axios promise
  promise.cancel = () => {
    abortController.abort('Query was cancelled');
  };

  return promise;
};

export type BodyType<BodyData> = BodyData;
